import React from 'react'

export default function Education() {
  return (
    <div className="block max-w-xl p-6 bg-cardbodybg border border-cardborder rounded-[30px] shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <p className="font-normal text-black dark:text-white lowercase">GMR Institute of Technology - june 2022.</p>
            <p className="font-normal text-black dark:text-white lowercase">Bachelor of Technology in Mechanical Engineering - 8.11 GPA</p>
        </div>
  )
}
